var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstitution = function SvgInstitution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.003 15.999"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m7.609.08-7 3a1 1 0 0 0 .393 1.919v.251a.748.748 0 0 0 .75.75h12.5a.748.748 0 0 0 .75-.75V5a1 1 0 0 0 .394-1.919l-7-3a1.013 1.013 0 0 0-.788 0ZM4.002 6.999h-2v6.135a.544.544 0 0 0-.056.034l-1.5 1a1 1 0 0 0 .556 1.831h14a1 1 0 0 0 .553-1.831l-1.5-1c-.019-.013-.038-.022-.056-.034V6.999h-2v6h-1.25v-6h-2v6h-1.5v-6h-2v6H4.002Zm4-5a1 1 0 1 1-1 1 1 1 0 0 1 1.001-1Z"
  })));
};
export default SvgInstitution;